import React from 'react';
import { Instagram, Mail } from 'lucide-react';
export const Footer: React.FC = () => {
  return <footer className="bg-white py-8 sm:py-10 px-4 sm:px-6 lg:px-8 border-t border-gray-100" data-id="element-95">
      <div className="max-w-7xl mx-auto" data-id="element-96">
        <ul className="flex justify-center gap-8 sm:gap-10 mb-5" data-id="element-97">
          <li data-id="element-98">
            <a href="https://www.instagram.com/moonstone__events" target="_blank" rel="noopener noreferrer" className="text-[#486878] hover:text-[#2c5aa0] transition-colors inline-flex items-center justify-center min-w-[44px] min-h-[44px]" aria-label="Instagram" data-id="element-99">
              <Instagram size={28} strokeWidth={1.5} data-id="element-100" />
            </a>
          </li>
          <li data-id="element-101">
            <a href="mailto:hello@moonstoneevents.com" className="text-[#486878] hover:text-[#2c5aa0] transition-colors inline-flex items-center justify-center min-w-[44px] min-h-[44px]" aria-label="Email" data-id="element-102">
              <Mail size={28} strokeWidth={1.5} data-id="element-103" />
            </a>
          </li>
        </ul>
        <ul className="flex justify-center" data-id="element-104">
          <li className="text-[#486878] text-sm sm:text-base text-center" data-id="element-105">
            &copy; 2025 Moonstone Events. All rights reserved.
          </li>
        </ul>
      </div>
    </footer>;
};